export default __webpack_public_path__ + "static/media/fa-regular-400.c9c57c0f.ttf";